angular.module('app.api').factory('EmploymentHistoryApi', [
  'api',
  function EmploymentHistoryApi(api) {
    const employmentHistoryApi = {
      editExperience: (id, experienceId, payload) => {
        return api.put(`users/${id}/experience/${experienceId}`, payload)
      },
      addExperience: (id, payload) => {
        return api.post(`users/${id}/experience`, payload)
      },
      deleteExperience: (id, experienceId) => {
        return api.delete(`users/${id}/experience/${experienceId}`)
      },
    }
    return employmentHistoryApi
  },
])



// WEBPACK FOOTER //
// ./scripts/candidate-profile/employment-history/employment-history.api.js